import React from 'react';

/**
 * Consultium Group logo.
 *
 * Renders the official brand logo PNG (icon + wordmark + tagline) for light
 * backgrounds. On dark backgrounds (variant="white") the icon PNG is paired
 * with a white wordmark so the mark stays legible.
 *
 * Usage:
 *   <ConsultiumLogo size="default" />
 *   <ConsultiumLogo size="large" variant="white" />
 */
const ConsultiumLogo = ({ className = '', size = 'default', variant = 'colored' }) => {
  const heights = { small: 32, default: 44, large: 64 };
  const height = heights[size] || heights.default;
  const isWhite = variant === 'white';

  if (isWhite) {
    return (
      <div
        className={`flex items-center gap-3 ${className}`}
        aria-label="Consultium Group"
        data-testid="consultium-logo"
      >
        <img
          src="/logo192.png"
          alt=""
          height={height}
          style={{ height, width: 'auto', display: 'block' }}
        />
        <span
          className="font-bold tracking-tight text-white"
          style={{ fontSize: Math.round(height * 0.55), lineHeight: 1 }}
        >
          Consultium Group
        </span>
      </div>
    );
  }

  return (
    <img
      src="/consultium-logo.png"
      alt="Consultium Group — Your One Stop Business Solutions Portal"
      height={height}
      className={className}
      style={{ height, width: 'auto', display: 'block' }}
      data-testid="consultium-logo"
    />
  );
};

export default ConsultiumLogo;
